import { FC } from 'react';
import DocumentRequestForm from '@components/CreateEditDocumentRequestForm/DocumentRequestForm';

// Placeholder - just renders form for now
const CreateEditDocumentRequestForm: FC = () => (
  <DocumentRequestForm />
);

export default CreateEditDocumentRequestForm;
